import { numCompare, roundDecimal, strCompareLowerCase } from "@common/Common";
import { AlternativeReadModel, CriterionReadModel } from "@Evaluation/ValueAnalysis/Domain/readmodels";
import { KendoChart, KendoChartDataSerie, KendoChartOptions } from "@Kendo/Components/KendoChart";

export class BarChartDialogViewModel
{
    opened: boolean = false;
    chart: KendoChart | null = null;
    criterionId: number | null = null;

    criteria: CriterionReadModel[] = [];
    selectedAlternatives: AlternativeReadModel[] = [];
    theme: string = "default";
    precision: number = 3;
    get selectedCriterion(): CriterionReadModel { return this.criteria.find(a => a.Id === this.criterionId); }

    setChartData(topLevel: boolean)
    {
        const criterionId = this.selectedCriterion.Id;

        const alternatives = this.selectedAlternatives.sort((a, b) =>
        {
            const aV = roundDecimal(a.Criteria.find(v => v.CriterionId === criterionId).Value, this.precision);
            const bV = roundDecimal(b.Criteria.find(v => v.CriterionId === criterionId).Value, this.precision);

            const comp = numCompare(aV, bV);

            if (comp !== 0)
            {
                return comp;
            }
            else
            {
                return strCompareLowerCase(a.Name, b.Name);
            }
        }).reverse();

        let criteria: CriterionReadModel[] = null;

        if (this.selectedCriterion.IsParent === false)
        {
            criteria = [this.selectedCriterion];
        }
        else
        {
            criteria = topLevel ?
                this.criteria.filter(c => c.ParentId === this.criterionId) :
                this.criteria.filter(c => this.selectedCriterion.BottomIds.includes(c.Id));
        }


        const series = criteria.map(c =>
        {
            const dataItems = alternatives.map(a =>
            {
                return {
                    AlternativeId: a.Id,
                    Name: a.Name,
                    Value: roundDecimal(a.Criteria.find(av => av.CriterionId === c.Id).Value, this.precision),
                    TooltipHtml: `<div style="text-align: left;"><h5>${a.Name}</h5><h5>${c.Name}<h5/></div>`
                }
            });

            const serie = new KendoChartDataSerie();
            serie.SetName(c.Name);
            serie.SetField("Value");
            serie.SetCategoryField("Name");
            serie.SetData(dataItems);

            return serie;
        });

        if (series.length > 0)
        {
            series[0].SetLabels(true, "#= category #", "1rem Verdana", "insideBase");
        }

        this.chart.SetDataSeries(series);
        this.chart.UpdateOptions();
    }

    renderChart()
    {
        this.chart.Render1("BarChart");
    }

    show(criteria: CriterionReadModel[], selectedAlternatives: AlternativeReadModel[], theme: string, precision: number)
    {
        this.criteria = criteria;
        this.selectedAlternatives = selectedAlternatives;
        this.theme = theme;
        this.precision = precision;

        this.criterionId = this.criteria.find(c => c.ParentId == null).Id;

        const chartOptions = new KendoChartOptions();
        chartOptions.SetBarSeriesType();
        chartOptions.SetSeriesStack(true);
        chartOptions.SetTooltip(true, "#= dataItem.TooltipHtml #");
        chartOptions.SetCategoryAxis(false, false);
        chartOptions.SetValueAxis(null, false, false);
        chartOptions.SetLegend(true, "bottom", 35);
        chartOptions.SetTheme(this.theme);
        chartOptions.SetHeight(Math.max(this.selectedAlternatives.length * 70, 400));

        this.chart = KendoChart.CreateChart(chartOptions);
        this.setChartData(true);

        this.opened = true;
    }


    close()
    {
        this.opened = false;

        this.chart = null;
    }
}